

export const dashboardNavList = [
    {
        id:1,
        item:"dashboard",
        linkTo:"dashboard-home",
    },
    {
        id:2,
        item:"advance",
        linkTo:"",
    },
    {
        id:3,
        item:"alarm",
        linkTo:"",
    },
    {
        id:4,
        item:"setting",
        linkTo:"",
    },
]